import React, { useState } from 'react';
import { ChevronDownIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { additionalServiceAreas, hours, locations, primaryServiceArea } from '../data/locations';
export function Locations() {
  const [showMore, setShowMore] = useState(false);
  const primary = locations[0];
  const satellites = locations.slice(1);
  return <section id="locations" aria-labelledby="locations-heading" className="w-full bg-kosin-charcoal" data-id="element-169" data-mp="1jo0thhtxbqjc">
      <div className="mx-auto max-w-shell px-[18px] py-12 sm:px-6 lg:py-20" data-id="element-170" data-mp="1eoxrk698q0fl">
        <h2 id="locations-heading" className="max-w-[640px] text-[28px] font-bold leading-tight text-white lg:text-[36px]" data-id="element-171" data-mp="1anvplhnxva9x">
          Visit Our Howell Showroom. Connect Locally.
        </h2>

        <div className="mt-9 grid grid-cols-1 gap-10 lg:grid-cols-[1.15fr_1fr] lg:gap-16" data-id="element-172" data-mp="10tdehrg70cg3">
          <div data-id="element-173" data-mp="302aj0f9wjlbr">
            <p className="text-[13px] font-semibold text-kosin-bright" data-id="element-174" data-mp="2v5adc5gyskl6">
              Main location
            </p>
            <h3 className="mt-2 text-[24px] font-semibold text-white" data-id="element-175" data-mp="16m3d69nu1grq">
              {primary.city} — Showroom &amp; Auto Glass Service Center
            </h3>
            <address className="mt-3 not-italic text-[17px] leading-relaxed text-white/80" data-id="element-176" data-mp="1aorlmg8mwlo6">
              {primary.address.map(line => <span key={line} className="block" data-id="element-177" data-mp="11m8n28bvsv7q">
                  {line}
                </span>)}
            </address>
            <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-178" data-mp="1pdnwsm5zmet0">
              <a href={primary.phoneHref} className="focus-light inline-flex items-center gap-2 text-[18px] font-semibold text-white hover:text-kosin-bright transition-colors duration-150 ease-kosin" data-id="element-179" data-mp="1uaeaj2ubkyb9">
                <PhoneIcon className="h-4 w-4 text-kosin-bright" aria-hidden="true" data-id="element-180" data-mp="1kj9vy48k3fgy" />
                {primary.phoneDisplay}
              </a>
              <a href={primary.directionsUrl} className="focus-light inline-flex items-center gap-1.5 text-[16px] font-semibold text-white underline decoration-white/40 underline-offset-4 hover:decoration-white transition-colors duration-150 ease-kosin" data-id="element-181" data-mp="2d270eoe3e3er">
                <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-182" data-mp="2cyoqt14889x4" />
                Get directions to Howell
              </a>
            </div>

            <h3 className="mt-10 text-[13px] font-semibold uppercase text-white/60" data-id="element-183" data-mp="2907i4d55qrdl">
              Business hours
            </h3>
            <dl className="mt-3 max-w-[380px] divide-y divide-white/10 border-y border-white/10" data-id="element-184" data-mp="1z8l7oj0n8wbw">
              {hours.map(row => <div key={row.day} className="flex justify-between py-2.5 text-[16px]" data-id="element-185" data-mp="1ua0aytklous7">
                  <dt className="text-white/80" data-id="element-186" data-mp="1pb6ucsa0onnt">{row.day}</dt>
                  <dd className="font-medium text-white" data-id="element-187" data-mp="1l8aj5mmt3ttw">{row.time}</dd>
                </div>)}
            </dl>
          </div>

          <div data-id="element-188" data-mp="1gas89qp8b4j9">
            <h3 className="text-[13px] font-semibold uppercase text-white/60" data-id="element-189" data-mp="1ga90v3x7fyjh">
              Satellite offices
            </h3>
            <ul className="mt-3 divide-y divide-white/10 border-y border-white/10" data-id="element-190" data-mp="3rz5id8u1g98q">
              {satellites.map(office => <li key={office.city} className="py-4" data-id="element-191" data-mp="4rv04v7iab4e">
                  <p className="text-[18px] font-semibold text-white" data-id="element-192" data-mp="4q0hjnjpiv3h">
                    {office.city}
                    <span className="ml-2 text-[13px] font-medium uppercase text-white/50" data-id="element-193" data-mp="9otsb87m07zy">
                      Satellite office
                    </span>
                  </p>
                  <address className="mt-1 not-italic text-[16px] leading-relaxed text-white/75" data-id="element-194" data-mp="3d869dwpajiom">
                    {office.address.map(line => <span key={line} className="block" data-id="element-195" data-mp="3mxzlcytchzte">
                        {line}
                      </span>)}
                  </address>
                  <a href={office.phoneHref} className="focus-light mt-1.5 inline-flex items-center gap-2 text-[16px] font-semibold text-white hover:text-kosin-bright transition-colors duration-150 ease-kosin" data-id="element-196" data-mp="2pghlcsji5gdh">
                    <PhoneIcon className="h-4 w-4 text-kosin-bright" aria-hidden="true" data-id="element-197" data-mp="w1g1ga8ifnav" />
                    {office.phoneDisplay}
                  </a>
                </li>)}
            </ul>

            <h3 className="mt-8 text-[13px] font-semibold uppercase text-white/60" data-id="element-198" data-mp="14z04nopxnto4">
              Service area
            </h3>
            <p className="mt-3 text-[16px] leading-relaxed text-white/80" data-id="element-199" data-mp="1eq346m37s0la">
              {primaryServiceArea}
            </p>
            <button type="button" className="focus-light mt-3 inline-flex items-center gap-1.5 text-[15px] font-semibold text-white hover:text-kosin-bright transition-colors duration-150 ease-kosin" aria-expanded={showMore} aria-controls="more-areas" onClick={() => setShowMore(v => !v)} data-id="element-200" data-mp="1sq5ixzg86dwb">
              More service areas
              <ChevronDownIcon className={`h-4 w-4 transition-transform duration-150 ease-kosin ${showMore ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-201" data-mp="3gcrpxk3ncntc" />
            </button>
            {showMore && <p id="more-areas" className="mt-3 text-[16px] leading-relaxed text-white/75" data-id="element-202" data-mp="3bkgp8f130xzq">
                {additionalServiceAreas.join(' · ')}
              </p>}
          </div>
        </div>
      </div>
    </section>;
}